<template>
    <div class="download-page">
        <form @submit.prevent="downloadUrl" enctype="multipart/form-data" class="header-search-form ts-from-url-link">
            <fieldset>
                <div class="input-sec ytb-url">
                    <span class="form-title">Youtube/Vimeo/MP3 URL</span>
                    <input type="text" v-model="dl_url" name="dl_url" class="form-control search-input" placeholder="youtube.com/watch?v=dQw4w9WgXcQ">
                </div>
                <div class="input-sec link-lang">
                    <span class="form-title">Language</span>
                    <select v-model="selected_lang">
                        <option v-for="(lang, key) in JSON.parse(langs)" :value="key">{{lang}}</option>
                    </select>
                </div>
            </fieldset>
            <button type="submit" class="header-search-button" :class="{'button-disabled' : !canDownload()}" :disabled="!canDownload()">Submit</button>
        </form>
        <div v-if="url_submitted && !prompt_register" class="listing-title">
            <br>
            <h4>Link submitted for transcription. Please wait.</h4>
            <svg class="ping-pong" viewBox="0 0 128 128" width="128px" height="128px">
                <defs>
                    <linearGradient id="ping-pong-grad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stop-color="#000" />
                        <stop offset="100%" stop-color="#fff" />
                    </linearGradient>
                    <mask id="ping-pong-mask">
                        <rect x="0" y="0" width="128" height="128" fill="url(#ping-pong-grad)" />
                    </mask>
                </defs>
                <g fill="var(--primary)">
                    <g class="ping-pong__ball-x">
                        <circle class="ping-pong__ball-y" r="10" />
                    </g>
                    <g class="ping-pong__paddle-x">
                        <rect class="ping-pong__paddle-y" x="-30" y="-2" rx="1" ry="1" width="60" height="4" />
                    </g>
                </g>
                <g fill="hsl(163,90%,40%)" mask="url(#ping-pong-mask)">
                    <g class="ping-pong__ball-x">
                        <circle class="ping-pong__ball-y" r="10" />
                    </g>
                    <g class="ping-pong__paddle-x">
                        <rect class="ping-pong__paddle-y" x="-30" y="-2" rx="1" ry="1" width="60" height="4" />
                    </g>
                </g>
            </svg>
            <br>
        </div>
        <br>
        <span v-if="userRole">Remaining Transcription Time: <span class="ts-time">{{ getReadableStartingPoint(transcript_time) }}</span></span>
        <div v-if="prompt_register" class="register-notice-message" :class="{'show-notice' : prompt_register}">
            <span class="heading"><a href="/pricing?place_src=tsp">Sign Up Now for Free and Get 25 Minutes of Transcription Time!</a></span>
            <span class="descriptor">Register today and receive 25 minutes of transcription time at no cost. Don't miss out—join now and start transcribing effortlessly!</span>
        </div>
        <span v-if="too_big" class="too-big-notice-message" :class="{'show-notice' : too_big}">The length of the media file ({{ getReadableStartingPoint(dl_length) }}) you've requested exceeds your remaining transcription time of {{ getReadableStartingPoint(transcriptTime) }} </span>
        <span v-if="invalid_url" class="too-big-notice-message" :class="{'show-notice' : invalid_url}">{{ invalid_url_text }}</span>
        <div v-if="is_queue && !transcript_started">
            <span>There are {{ queue_count }} transcriptions ahead of you. Approximate Wait time is {{ getReadableStartingPoint(queue_length) }}. You can stay on this page as we queue up your transcription. Once the transcript is ready, you'll be able to access anytime from this page.</span>
        </div>
        <div v-if="transcript_started">
            <span>Transcription Started</span>
            <span>{{ getReadableStartingPoint(time_progress) }}</span>
        </div>
        <div v-if="dl_message !== ''">
            <span>{{ dl_message }}</span>
        </div>
        <div v-else-if="transcript_data.progress > 0" id="progressbar">
            <div :style='"width:"+ transcript_data.progress'>{{ transcript_data.progress }}</div>
        </div>
        <div v-if="transcript_ready">
            <form @submit.prevent="downloadUrl" enctype="multipart/form-data" class="dl-form">
                <div class="dropdown">
                    <div class="select" v-on:click.stop.prevent="dropDownInit">
                        <span class="selected">Download</span>
                        <div class="caret"></div>
                    </div>
                    <ul class="menu">
                        <li v-on:click.stop.prevent="downloadFileType(transcript_data.id, 'json', true)" class="json">JSON</li>
                        <li v-on:click.stop.prevent="downloadFileType(transcript_data.id, 'txt', true)" class="txt">TXT</li>
                        <li v-on:click.stop.prevent="downloadFileType(transcript_data.id, 'srt', true)" class="srt">SRT</li>
                    </ul>
                </div>
            </form>
            <h2 class="current-transcript-title">{{ transcript_data.title }}</h2>
            <div class="single-sentence" v-for="ts in JSON.parse(transcript_data.transcript).chunks">
                <span>{{ getTSStartingPoint(ts.timestamp[0]) }} {{ ts.text }}</span>
            </div>
        </div>
        <div class="is_loading_indicator" v-if="show_spinner">
            <svg v-if="pong_spinner" class="ping-pong" viewBox="0 0 128 128" width="128px" height="128px">
                <defs>
                    <linearGradient id="ping-pong-grad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stop-color="#000" />
                        <stop offset="100%" stop-color="#fff" />
                    </linearGradient>
                    <mask id="ping-pong-mask">
                        <rect x="0" y="0" width="128" height="128" fill="url(#ping-pong-grad)" />
                    </mask>
                </defs>
                <g fill="var(--primary)">
                    <g class="ping-pong__ball-x">
                        <circle class="ping-pong__ball-y" r="10" />
                    </g>
                    <g class="ping-pong__paddle-x">
                        <rect class="ping-pong__paddle-y" x="-30" y="-2" rx="1" ry="1" width="60" height="4" />
                    </g>
                </g>
                <g fill="hsl(163,90%,40%)" mask="url(#ping-pong-mask)">
                    <g class="ping-pong__ball-x">
                        <circle class="ping-pong__ball-y" r="10" />
                    </g>
                    <g class="ping-pong__paddle-x">
                        <rect class="ping-pong__paddle-y" x="-30" y="-2" rx="1" ry="1" width="60" height="4" />
                    </g>
                </g>
            </svg>

            <svg v-if="wave_spinner" class="pl" viewBox="0 0 128 128" width="128px" height="128px">
                <defs>
                    <linearGradient id="pl-grad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stop-color="#000" />
                        <stop offset="100%" stop-color="#fff" />
                    </linearGradient>
                    <mask id="pl-mask">
                        <rect x="0" y="0" width="128" height="128" fill="url(#pl-grad)" />
                    </mask>
                </defs>
                <g stroke-linecap="round" stroke-width="8" stroke-dasharray="32 32">
                    <g stroke="hsl(193,90%,50%)">
                        <line class="pl__line1" x1="4" y1="48" x2="4" y2="80" />
                        <line class="pl__line2" x1="19" y1="48" x2="19" y2="80" />
                        <line class="pl__line3" x1="34" y1="48" x2="34" y2="80" />
                        <line class="pl__line4" x1="49" y1="48" x2="49" y2="80" />
                        <line class="pl__line5" x1="64" y1="48" x2="64" y2="80" />
                        <g transform="rotate(180,79,64)">
                            <line class="pl__line6" x1="79" y1="48" x2="79" y2="80" />
                        </g>
                        <g transform="rotate(180,94,64)">
                            <line class="pl__line7" x1="94" y1="48" x2="94" y2="80" />
                        </g>
                        <g transform="rotate(180,109,64)">
                            <line class="pl__line8" x1="109" y1="48" x2="109" y2="80" />
                        </g>
                        <g transform="rotate(180,124,64)">
                            <line class="pl__line9" x1="124" y1="48" x2="124" y2="80" />
                        </g>
                    </g>
                    <g stroke="hsl(283,90%,50%)" mask="url(#pl-mask)">
                        <line class="pl__line1" x1="4" y1="48" x2="4" y2="80" />
                        <line class="pl__line2" x1="19" y1="48" x2="19" y2="80" />
                        <line class="pl__line3" x1="34" y1="48" x2="34" y2="80" />
                        <line class="pl__line4" x1="49" y1="48" x2="49" y2="80" />
                        <line class="pl__line5" x1="64" y1="48" x2="64" y2="80" />
                        <g transform="rotate(180,79,64)">
                            <line class="pl__line6" x1="79" y1="48" x2="79" y2="80" />
                        </g>
                        <g transform="rotate(180,94,64)">
                            <line class="pl__line7" x1="94" y1="48" x2="94" y2="80" />
                        </g>
                        <g transform="rotate(180,109,64)">
                            <line class="pl__line8" x1="109" y1="48" x2="109" y2="80" />
                        </g>
                        <g transform="rotate(180,124,64)">
                            <line class="pl__line9" x1="124" y1="48" x2="124" y2="80" />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        <div v-if="has_transcripts" class="user_transcripts user-transcripts-section">
            <span class="title" >Your Transcripts</span>
            <div class="single-transcript" v-for="(transcript, key) in user_transcripts">
                <span class="see-podcasts" v-on:click="collapseTranscript"><span class="single-transcript-section-expand-button">{{ transcript.title }}</span> <i class="fa fa-arrow-down"></i></span>
                <div class="single-transcript-section">
                    <span class="get_transcript_button" v-on:click.stop.prevent="getSingleTranscript(transcript.id, key)">Show Transcript</span>
                    <form @submit.prevent="downloadUrl" enctype="multipart/form-data" class="dl-form">
                        <div class="dropdown">
                            <div class="select" v-on:click.capture="dropDownInit">
                                <span class="selected">Download Transcript</span>
                                <div class="caret"></div>
                            </div>
                            <ul class="menu">
                                <li v-on:click.stop.prevent="downloadFileType(transcript.id, 'json')" class="json">JSON</li>
                                <li v-on:click.stop.prevent="downloadFileType(transcript.id, 'txt')" class="txt">TXT</li>
                                <li v-on:click.stop.prevent="downloadFileType(transcript.id, 'srt')" class="srt">SRT</li>
                            </ul>
                        </div>
                    </form>
                    <div v-if="transcript.transcript">
                        <div class="single-sentence" v-for="ts in JSON.parse(transcript.transcript).chunks">
                            <span>{{ getTSStartingPoint(ts.timestamp[0]) }} {{ ts.text }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default{
        props: ['searchedkeywords', 'userRole', 'transcriptTime', 'userId', 'langs'],
        data(){
            return {
                dl_url: '',
                dl_id: null,
                dl_progress: 0,
                dl_length: 0,
                time_progress: 0,
                selected_lang: 'en',
                queue_progress: 0,
                dl_check_progress: false,
                dl_finished: false,
                dl_started: false,
                dl_message: '',
                transcript_ready: false,
                sentence_wrap: 8,
                transcript_data: '',
                show_spinner: false,
                pong_spinner: false,
                time_progress_started: false,
                url_submitted: false,
                transcript_started: false,
                transcript_time: 0,
                wave_spinner: true,
                prompt_register: false,
                has_transcripts: false,
                is_queue: false,
                queue_count: 0,
                queue_length: 0,
                user_transcripts: {},
                too_big: false,
                invalid_url: false,
                invalid_url_text: '',
            }
        },
        watch: {
            keywords_to_search(dl_url) {
                this.keywords_to_search = dl_url;
            }
        },
        mounted() {
            this.transcript_time = this.transcriptTime;
            if (this.userRole) {
                this.getExistingTranscripts();
                this.updateUserTranscriptTime();
            }
        },
        beforeDestroy() {
            clearInterval(this.timer)
            clearInterval(this.ts_timer)
            clearInterval(this.queue_timer)
            clearInterval(this.check_queue_timer)
            clearInterval(this.check_ready_timer)
        },
        computed: {
            transcriptGroups() {
                return Array.from(Array(Math.ceil(JSON.parse(this.transcript_data.transcript).chunks.length / this.sentence_wrap)).keys())
            }
        },
        methods: {
            updateUserTranscriptTime() {
                axios.post('/api/getremainingusertime/').then(response => {
                    this.transcript_time = response.data.transcript_time;
                });
            },
            checkQueueStatus(id) {
                axios.post('/api/checkqueue/',{
                    ts_id: id,
                }).then(response => {
                    console.log(response.data);
                    if (parseInt(response.data) !== parseInt(this.queue_count)) {
                        this.queue_length = (response.data * 30);
                        this.queue_count = response.data;
                        if (response.data === 0) {
                            clearInterval(this.check_queue_timer);
                            this.queue_count = 0;
                        }
                    }
                    //console.log(response.data);
                });
            },
            getExistingTranscripts() {
                axios.post('/api/getusertranscripts/', {
                    user_id: this.userId,
                }).then(response => {
                    this.user_transcripts = response.data;
                    this.has_transcripts = true;
                });
            },
            getSingleTranscript(id, key) {
                if (this.user_transcripts[key].transcript === undefined) {
                    let _this = this;
                    axios.post('/api/checkdownloadprogress/', {
                        dl_id: id,
                    }).then(response => {
                        _this.user_transcripts.forEach(anObj => {
                            if (anObj.id === id) {
                                this.$set(anObj, 'transcript', response.data.transcript);
                            }
                        });
                    });
                }
            },
            getSampleData() {
                axios.post('/api/checkdownloadprogress/', {
                    dl_id: 3,
                }).then(response => {
                    this.transcript_data = response.data;
                    this.transcript_ready = true;
                });
            },
            canDownload() {
                if(this.dl_url !== '') {
                    return true;
                }
            },
            startProgressTimer() {
                this.ts_timer = setInterval(() => {
                    this.time_progress++;
                }, 1000)
            },
            startQueueTimer() {
                this.queue_timer = setInterval(() => {
                    if (this.queue_length === 0) {
                        clearInterval(this.queue_timer)
                        clearInterval(this.check_queue_timer)
                    } else {
                        this.queue_length--;
                    }
                }, 1000)
            },
            dropDownInit(e) {
                let trg_el = e.target.closest('.dropdown');
                trg_el.querySelector('.caret').classList.toggle("caret-rotate");
                trg_el.querySelector('.menu').classList.toggle("menu-open")
            },
            collapseTranscript(e) {
                if (e.target.parentElement.parentElement.classList.contains('expanded')) {
                    e.target.parentElement.parentElement.classList.remove('expanded');
                } else {
                    document.querySelectorAll(".single-transcript").forEach((element) =>
                        element.classList.remove('expanded')
                    );
                    e.target.parentElement.parentElement.classList.toggle('expanded');
                }
            },

            downloadFileType(ts_id, dl_type, new_dl = false) {
                let ts_data;
                if (new_dl) {
                    ts_data = this.slugify(this.transcript_data.title , '_')+'.'+dl_type;
                } else {
                    ts_data = this.slugify(this.user_transcripts.find(x => x.id === ts_id).title , '_')+'.'+dl_type;
                }
                axios.post('/api/getdownloadabletranscript/',{
                    dl_type: dl_type,
                    dl_id: ts_id,
                    responseType: 'blob',
                }).then(response => {
                    let res_blob;
                    if (dl_type === 'json') {
                        res_blob = new Blob([JSON.stringify(response.data)]);
                    } else {
                        res_blob = new Blob([response.data]);
                    }
                    const aElement = document.createElement('a');
                    aElement.setAttribute('download', ts_data);
                    const href = URL.createObjectURL(res_blob);
                    aElement.href = href;
                    aElement.setAttribute('target', '_blank');
                    aElement.click();
                    URL.revokeObjectURL(href);
                })
            },
            getTSStartingPoint(st_time) {
                let date = new Date(0);
                date.setSeconds(st_time); // specify value for SECONDS here
                let timeString = date.toISOString().substring(11, 19);
                return timeString;
            },
            getReadableStartingPoint(ts_sec) {
                const hours = Math.floor(ts_sec / 3600)
                const minutes = Math.floor((ts_sec % 3600) / 60)
                const remainingSeconds = ts_sec % 60

                const hourString = hours > 0 ? `${hours} hour${hours > 1 ? 's' : ''}` : ''
                const minuteString = minutes > 0 ? `${minutes} minute${minutes > 1 ? 's' : ''}` : ''
                const secondString =
                    remainingSeconds > 0 ? `${remainingSeconds} second${remainingSeconds > 1 ? 's' : ''}` : ''

                if (hours > 0) {
                    return `${hourString} : ${minuteString || '0 minutes'} ${secondString && `: ${secondString}`}`
                } else if (!hours && minutes > 0) {
                    return `${minuteString} ${secondString && `: ${secondString}`}`
                }

                return secondString
            },
            slugify(text, divider = '-'){
                return text
                    .toString()                   // Cast to string (optional)
                    .normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
                    .toLowerCase()                // Convert the string to lowercase letters
                    .trim()                       // Remove whitespace from both sides of a string (optional)
                    .replace(/\s+/g, divider)         // Replace spaces with -
                    .replace(/[^\w\-]+/g, '')     // Remove all non-word chars
                    .replace(/\-\-+/g, divider)       // Replace multiple - with single -
                    .replace(/\_\_+/g, divider)       // Replace multiple - with single -
                    .replace(/\-$/g, '');         // Remove trailing -
            },
            checkTranscriptReady(dl_id) {
                axios.post('/api/checkdownloadprogress/',{
                    dl_id: dl_id,
                }).then(response => {
                    this.transcript_data = response.data;
                    if (response.data.transcribe_started === 1) {
                        this.transcript_started = true;
                        this.url_submitted = false;
                        this.show_spinner = true;
                        if (!this.time_progress_started) {
                            this.time_progress_started = true;
                            this.startProgressTimer();
                        }
                    }
                    if (response.data.finished === 1) {
                        this.transcript_ready = true;
                        clearInterval(this.check_ready_timer);
                        clearInterval(this.ts_timer);
                        this.updateUserTranscriptTime();
                        this.url_submitted = false;
                        this.show_spinner = false;
                    }
                })
            },
            checkDownloadStarted(dl_id) {
                axios.post('/api/checkdownloadstarted/',{
                    dl_id: dl_id,
                }).then(response => {
                    this.dl_started = response.data.dl_started;
                })
                if(this.dl_started === 1) {
                    this.dl_started = true;
                    this.dl_check_progress = true;
                    clearInterval(this.dl_timer)
                    if (this.dl_check_progress) {
                        this.timer = setInterval(() => {
                            this.checkDownloadProgress(this.dl_id);
                        }, 3000)
                    }
                }
            },
            sendStartSignal() {
                const socket = new WebSocket("wss://ws.podscripts.co");
                socket.onopen = (event) => {
                    socket.send('start_transcript');
                };
                socket.addEventListener("message", event => {
                    let response = JSON.parse(event.data);
                    if (response.status === 'queue') {
                        this.is_queue = true;
                        this.queue_count = response.count_data.count;
                        this.queue_length = (response.count_data.count * 30);
                        this.startQueueTimer();
                        this.check_queue_timer = setInterval(() => {
                            this.checkQueueStatus(this.dl_id);
                        }, 5000)

                    } else if (response.status === 'started') {
                        console.log('started ts');
                    }
                })
            },
            checkDownloadProgress(dl_id) {
                axios.post('/api/checkdownloadprogress/',{
                    dl_id: dl_id,
                }).then(response => {
                    this.dl_progress = response.data.progress;
                })
                if(this.dl_progress === '100%') {
                    this.dl_progress = '100%';
                    this.dl_finished = true;
                    clearInterval(this.timer)
                    this.sendStartSignal();
                }
            },
            downloadUrl() {
                let _this = this;
                if (this.canDownload()) {
                    if (!this.userRole) {
                        _this.url_submitted = true;
                        this.prompt_register = true;
                        axios.get('/sanctum/csrf-cookie').then(response => {
                            axios.post('/api/downloadfromurl_noreg/', {
                                dl_url: this.dl_url,
                                selected_lang: this.selected_lang,
                            });
                        });
                    } else {
                        _this.url_submitted = true;
                        _this.invalid_url = false;
                        _this.too_big = false;
                        axios.get('/sanctum/csrf-cookie').then(response => {
                            axios.post('/api/downloadfromurl/', {
                                dl_url: this.dl_url,
                                selected_lang: this.selected_lang,
                            }).then(response => {
                                if (response.data.status === 'too_big') {
                                    _this.too_big = true;
                                    _this.dl_length = response.data.dl_length;
                                    _this.url_submitted = false;
                                } else if (response.data.status === 'invalid_url') {
                                    _this.invalid_url = true;
                                    _this.invalid_url_text = response.data.text;
                                    _this.url_submitted = false;
                                } else if (response.data.id !== '') {
                                    _this.dl_id = response.data.id;
                                    _this.sendStartSignal();
                                    _this.check_ready_timer = setInterval(() => {
                                        this.checkTranscriptReady(this.dl_id);
                                    }, 3500)
                                }
                            })
                        });
                    }
                }
            },
        }
    }
</script>
